import { render } from "./PollVote.vue?vue&type=template&id=66807948&scoped=true"
import script from "./PollVote.vue?vue&type=script&lang=js"
export * from "./PollVote.vue?vue&type=script&lang=js"

import "./PollVote.vue?vue&type=style&index=0&id=66807948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66807948"]])

export default __exports__